export const certificates = {
  title: "Certificados",
  new: "Añadir certificado",
  replace: "Sustituir certificado",
  detail: "Certificado",
  tabs: {
    overview: "Resumen",
    versions: "Versiones",
    versionsCount: "Versiones ({{count}})",
    access: "Quién puede usarlo",
    activity: "Actividad",
  },
  list: {
    description:
      "Los certificados de la organización: quién los usa y cuándo caducan.",
    search: "Buscar por nombre, titular o NIF",
    filters: {
      type: "Tipo",
      status: "Estado",
      expiring: "Caduca",
      expiringIn: "En menos de {{count}} días",
    },
    columns: {
      name: "Nombre",
      company: "Empresa · NIF",
      type: "Tipo",
      issuer: "Emisor",
      expires: "Caduca",
      people: "Personas",
      status: "Estado",
    },
    peopleHint: "Personas con acceso efectivo según las políticas",
    emptyTitle: "Todavía no hay certificados",
    emptyDescription:
      "Añade el primero subiendo su .p12: la clave va directa a KMS y el fichero no se guarda.",
  },
  expiry: {
    inDays_one: "en {{count}} día",
    inDays_other: "en {{count}} días",
    expired: "Caducado",
    none: "Sin versión activa",
  },
  actions: {
    delete: "Borrar",
    replace: "Sustituir",
    suspend: "Suspender",
    reactivate: "Reactivar",
    rename: "Cambiar nombre",
  },
  suspend: {
    title: "¿Suspender este certificado?",
    description:
      "Deja de firmar al instante en todos los Macs y desaparece de la app. No se borra nada: puedes reactivarlo cuando quieras.",
    reason: "Motivo (queda en el registro)",
    reasonPlaceholder: "Por ejemplo: revisión de las facturas de septiembre",
    confirm: "Suspender",
    done: "Certificado suspendido",
  },
  delete: {
    title: "¿Borrar este certificado?",
    description:
      "Nunca ha llegado a estar activo: se borran sus versiones pendientes y, si se importó la clave, se programa su destrucción.",
    confirm: "Borrar",
    done: "Certificado borrado",
  },
  reactivate: {
    title: "¿Reactivar este certificado?",
    description:
      "Vuelve a firmar en cuanto lo reciban los Macs, según las políticas que lo incluyen.",
    confirm: "Reactivar",
    done: "Certificado reactivado",
  },
  suspendedBanner: "Suspendido {{date}}: {{reason}}",
  noValidVersionBanner:
    "No tiene ninguna versión válida: no firma. Sube una nueva con «Sustituir».",
  expiringBanner:
    "La versión activa caduca {{when}}. Sustitúyela antes para que nadie se quede sin acceso.",
  overview: {
    certificate: "Certificado",
    key: "Clave",
    dates: "Fechas",
    name: "Nombre",
    description: "Descripción",
    holder: "Titular",
    holderTaxId: "NIF del titular",
    company: "Empresa",
    companyTaxId: "NIF de la empresa",
    issuer: "Emisor",
    type: "Tipo",
    serial: "Número de serie",
    sha1: "Huella SHA-1",
    sha256: "Huella SHA-256",
    subject: "Sujeto",
    issuerDn: "Emisor (DN)",
    keyUsages: "Usos de la clave",
    extendedKeyUsages: "Usos extendidos",
    keyBackend: "Dónde está la clave",
    keyBackends: {
      kms: "AWS KMS (no exportable)",
      local: "Fichero local (solo desarrollo)",
    },
    keySpec: "Tipo de clave",
    keyRef: "Referencia",
    validity: "Validez",
    validityRange: "{{from}} – {{to}}",
    activatedAt: "Activa desde",
    createdAt: "Alta",
    noActiveVersion: "No hay versión activa.",
    renameTitle: "Nombre y descripción",
    renameHint:
      "El nombre lo pones tú; empresa, NIF, tipo y emisor salen del certificado.",
    nameRequired: "Escribe un nombre",
    saved: "Nombre guardado",
  },
  versions: {
    description:
      "Políticas y personas apuntan al certificado, no a una versión: al sustituirlo siguen igual.",
    columns: {
      version: "Versión",
      holder: "Titular",
      validity: "Validez",
      status: "Estado",
      actions: "Acciones",
    },
    number: "v{{number}}",
    active: "Activa",
    retiredReplaced: "Retirada por sustitución",
    retiredCompromised: "Retirada por compromiso",
    keyDestroyedIn_one: "la clave se destruye en {{count}} día",
    keyDestroyedIn_other: "la clave se destruye en {{count}} días",
    keyDestroyed: "clave destruida",
    scheduledFor: "Se activa el {{date}}",
    rollback: "Volver a esta",
    rollbackTitle: "¿Volver a la versión {{number}}?",
    rollbackDescription:
      "Se reactiva su clave, se cancela su destrucción y pasa a ser la activa. La actual queda retirada y también se puede volver a ella durante 30 días.",
    rollbackDone: "Has vuelto a la versión {{number}}",
    activate: "Activar ahora",
    activateTitle: "¿Activar la versión {{number}}?",
    activateDescription:
      "Pasa a ser la activa al momento; la anterior se retira, su clave se desactiva y se destruye en 30 días (puedes volver atrás mientras tanto).",
    activated: "Versión {{number}} activa",
    unschedule: "Cancelar programación",
    unscheduled: "Programación cancelada",
    retire: "Retirar",
    retireTitle: "¿Retirar la versión {{number}}?",
    retireDescription:
      "Su clave se desactiva al momento. Si es la activa y no hay otra, el certificado deja de firmar.",
    retireReason: "Motivo",
    retireReplaced:
      "Ya no se usa: la clave se destruye en 30 días y se puede volver a ella",
    retireCompromised:
      "Compromiso o revocación: la clave se destruye en 7 días, sin vuelta atrás",
    retireNote: "Nota (opcional)",
    retired: "Versión retirada",
    download: "Descargar certificado",
    downloaded: "Certificado descargado",
    empty: "Este certificado todavía no tiene versiones.",
  },
  access: {
    count_one: "{{count}} persona puede usarlo",
    count_other: "{{count}} personas pueden usarlo",
    none: "Nadie puede usarlo todavía",
    noneDescription:
      "Sin una política que lo permita no se ve ni se usa (denegado por defecto).",
    giveAccess: "Dar acceso",
    giveAccessNew: "En una política nueva",
    giveAccessExisting: "Añadirlo a una política existente",
    columns: {
      person: "Persona",
      where: "Dónde",
      policy: "Por la política",
    },
    except: "excepto {{what}}",
    viaGroup: "grupo {{name}}",
    policies: "Políticas que lo incluyen",
    noPolicies: "Ninguna política lo incluye.",
    disabled: "desactivada",
  },
  activity: {
    signatures: "Últimas firmas",
    navigation: "Última navegación",
    seeAll: "Ver todo en Actividad",
    emptySignatures: "Todavía no se ha firmado con este certificado.",
    emptyNavigation: "No hay navegación registrada con este certificado.",
    columns: {
      when: "Cuándo",
      person: "Persona",
      where: "Dónde",
      result: "Resultado",
      request: "Petición",
    },
  },
  wizard: {
    steps: {
      upload: "Subir el .p12",
      review: "Revisar",
      activate: "Activar",
      name: "Nombre y acceso",
    },
    stepOf: "Paso {{current}} de {{total}}",
    upload: {
      file: "Fichero .p12 o .pfx",
      fileHint: "Máximo 64 KB.",
      fileRequired: "Elige el fichero del certificado",
      fileType: "Tiene que ser un .p12 o .pfx",
      fileTooBig: "El fichero no puede pasar de 64 KB",
      password: "Contraseña del fichero",
      passwordRequired: "Escribe la contraseña",
      notStored:
        "El fichero y la contraseña no se guardan: la clave privada se importa directamente en AWS KMS como no exportable y el .p12 no llega a escribirse en disco.",
      kmsLink: "Ya tengo la clave en KMS",
      p12Link: "Subir un .p12",
      keyRef: "ARN o id de la clave en KMS",
      keyRefRequired: "Escribe el ARN de la clave",
      certificate: "Certificado (.cer, .crt, .pem o .der)",
      certificateRequired: "Elige el certificado",
      kmsHint:
        "Para casos raros: la clave ya está en KMS (o CloudHSM). Se comprueba que la clave pública del certificado coincide con la de KMS.",
      submit: "Continuar",
      uploading: "Comprobando el certificado…",
      duplicate: "Este certificado ya está dado de alta en la organización.",
      wrongPassword: "La contraseña no es correcta",
    },
    review: {
      title: "Revisa el certificado",
      newTitle: "Esto es lo que hay en el certificado",
      current: "Versión activa",
      next: "Nueva",
      changes: "cambia",
      company: "Empresa",
      companyTaxId: "NIF",
      holder: "Titular",
      issuer: "Emisor",
      type: "Tipo",
      validity: "Validez",
      until: "hasta {{date}}",
      serial: "Número de serie",
      keep: "Políticas y personas se mantienen: apuntan al certificado, no a esta versión.",
      holderChanged:
        "Cambia el titular. Políticas y personas se mantienen: apuntan al certificado, no a esta versión.",
      issuerChanged: "Cambia el emisor del certificado.",
      noActive: "No hay versión activa con la que comparar.",
      taxIdTitle: "Cambia el NIF de la empresa",
      taxIdDescription:
        "El certificado nuevo es de {{newCompany}} ({{newTaxId}}) y el actual de {{previousCompany}} ({{previousTaxId}}). Si es correcto, escribe el NIF nuevo para continuar: todas las personas con acceso pasarán a firmar en nombre de otra empresa.",
      taxIdInput: "NIF nuevo",
      taxIdMismatch: "No coincide con el NIF del certificado nuevo",
      taxIdConfirm: "Confirmar el cambio de NIF",
    },
    activate: {
      title: "¿Cuándo se activa?",
      now: "Activar ahora",
      nowHint:
        "La versión actual se retira al momento. Puedes volver a ella durante 30 días.",
      schedule: "Programar",
      scheduleHint: "Hasta entonces sigue firmando la versión actual.",
      at: "Fecha y hora",
      atRequired: "Elige una fecha y hora futura",
      submitNow: "Activar",
      submitSchedule: "Programar",
      doneNow: "Certificado sustituido: la versión {{number}} ya está activa",
      doneScheduled: "Sustitución programada para el {{date}}",
    },
    name: {
      title: "Ponle nombre",
      name: "Nombre",
      nameHint:
        "Es lo que verán las personas en la app y en «Mis certificados».",
      nameRequired: "Escribe un nombre",
      description: "Descripción (opcional)",
      giveAccess: "Dar acceso ahora",
      giveAccessHint:
        "Abre el editor de políticas con este certificado ya puesto. Si no, nadie podrá usarlo hasta que lo añadas a una política.",
      submit: "Añadir certificado",
      done: "Certificado añadido",
    },
    cancel: "Cancelar",
  },
};
